import { TFunction } from 'i18next';

export enum BankIdError {
    ERR_BANKID_BIRTH_NO_IS_DIFFERENT = 'err_bankId_birth_no_is_different',
    ERR_BANKID_LAST_NAME_IS_DIFFERENT = 'err_bankId_last_name_is_different',
    ERR_BANKID_BIRTH_DATE_IS_DIFFERENT = 'err_bankId_birth_date_is_different',
    ERR_NATIONALITY_NOT_DMSTC = 'err_nationality_not_dmstc',
    ERR_ID_CARD_NOT_DMSTC = 'err_idCard_not_dmstc',
}

const errorDescription = (isBankIdError: boolean, cannotFinish?: boolean) => {
    if (cannotFinish)
        return 'Na základě dat poskytnutých Vaší bankou není momentálně možné dokončit Vaši identifikaci prostřednictvím BankId. V případě dotazů nás, prosím,  kontaktujte.';
    return !isBankIdError
        ? 'Některé údaje, které o vás vedeme v našem systému, neodpovídají údajům z BankId. Proces BankId můžete případně zopakovat kliknutím na tlačítko níže.'
        : '';
};

export const errorLayoutProps = (
    isInvalid: boolean,
    t: TFunction<'translation', undefined>,
    isCustomError = false,
    isBankIdError = false,
    cannotFinish?: boolean
) => {
    if (isCustomError) {
        return {
            headline: 'Aj, vypadá to, že něco je špatně',
            description: errorDescription(isBankIdError, cannotFinish),
        };
    } else {
        return {
            headline: isInvalid ? t('errorPage.headline') : '',
            description: isInvalid ? t('errorPage.description') : '',
        };
    }
};
export const bankIdErrorMapper: { [K in BankIdError]: string } = {
    [BankIdError.ERR_BANKID_BIRTH_NO_IS_DIFFERENT]:
        'Identifikátor z BankId neodpovídá identifikátoru uloženému v našem systému (identifikátorem se rozumí např. rodné číslo).',
    [BankIdError.ERR_BANKID_LAST_NAME_IS_DIFFERENT]: 'Příjmení z BankId neodpovídá příjmení uloženému v našem systému.',
    [BankIdError.ERR_BANKID_BIRTH_DATE_IS_DIFFERENT]:
        'Datum narození z BankId neodpovídá datu narození uloženému v našem systému.',
    [BankIdError.ERR_NATIONALITY_NOT_DMSTC]: 'Momentálně není možné dokončit Vaši identifikaci prostřednictvím BankId.',
    [BankIdError.ERR_ID_CARD_NOT_DMSTC]: 'Momentálně není možné dokončit Vaši identifikaci prostřednictvím BankId.',
};
